module.exports = __webpack_public_path__ + "static/img/performance03.c973ae7e.jpg";